import {
  Condition,
  NumClaimsOption,
} from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export interface NumCustomerClaimsState {
  numClaims: string;
  claimOption: NumClaimsOption | null;
}

export const NUM_CUSTOMER_CLAIMS = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<NumCustomerClaimsState>
  >,
): ConditionType<NumCustomerClaimsState, Condition.NumCustomerClaims> => ({
  name: "Number of previous customer claims",
  description(state) {
    if (!state.claimOption) {
      return "The total number of claims this customer has previously made";
    }
    return `Number of previous claims ${state.claimOption.toLowerCase()} ${state.numClaims}`;
  },
  Details(props: ConditionTypeDetailsProps<NumCustomerClaimsState>) {
    return React.createElement(Details, props);
  },
  empty: { numClaims: (0).toFixed(0), claimOption: null },
  fromModel(model) {
    return {
      numClaims: model.numClaims.toFixed(0),
      claimOption: model.numClaimsOption,
    };
  },
  toModel(state) {
    return {
      type: Condition.NUM_CUSTOMER_CLAIMS,
      numClaims: +state.numClaims,
      numClaimsOption: state.claimOption,
    };
  },
  valid(state) {
    return (
      state.claimOption !== null &&
      +state.numClaims >= 0 &&
      +state.numClaims % 1 === 0 // Must be whole number
    );
  },
});
